export default __webpack_public_path__ + "fonts/a3a21164c982ef064b4946f4024acff7cac7b002ebd85799a41c8120a80f0935.ttf";